<template>
  <div class="health-bar-container">
    <div class="health-label">Health</div>
    <div class="health-bar">
      <div 
        class="health-bar-fill" 
        :style="{ width: healthPercentage + '%', backgroundColor: healthColor }"
      ></div>
    </div>
    <div class="health-value">{{ currentHealth }}/{{ maxHealth }}</div>
  </div>
</template>

<script>
export default {
  name: 'HealthBar',
  props: {
    currentHealth: {
      type: Number,
      required: true
    },
    maxHealth: {
      type: Number,
      default: 100
    }
  },
  computed: {
    healthPercentage() {
      return (this.currentHealth / this.maxHealth) * 100;
    },
    healthColor() {
      if (this.healthPercentage <= 20) {
        return '#f44336'; // Red for critical health
      } else if (this.healthPercentage <= 50) {
        return '#ff9800'; // Orange for medium health
      } else {
        return '#4caf50'; // Green for good health
      }
    }
  }
};
</script>

<style scoped>
.health-bar-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 15px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.health-label {
  font-weight: bold;
  min-width: 60px;
}

.health-bar {
  position: relative;
  width: 150px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  overflow: hidden;
}

.health-bar-fill {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
  border-radius: 10px;
}

.health-value {
  min-width: 60px;
  text-align: right;
}
</style> 